
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Organization } from '@/types';

export const useOrganizations = () => {
  return useQuery({
    queryKey: ['organizations-with-workspaces'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('organizations')
        .select(`
          id,
          name,
          color,
          workspaces (
            id,
            name,
            organization_id,
            boards (
              id,
              name,
              background_url,
              is_starred,
              last_viewed_at
            )
          )
        `)
        .order('name');

      if (error) throw error;
      return data as Organization[] || [];
    }
  });
};
